<template>
    <div class="home-page">
		<Header></Header>
		<div class="mission">
      <div class="mission-content">
        <div class="mission-h" style="background-image: none;">
          <div class="fs27" v-html="$t('referralTips1')"></div>
        </div>
        <div class="referral-list">
          <div class="mission-ul">
            <div class="mission-t" style="font-size:46px;margin-top:5px;line-height: 42px;">
              {{$t('memberGetMember')}}
            </div>
            <div class="referral-c">
              <div class="ac">
                <div class="">{{$t('referralTips2')}}</div>
                <div class="fen title-bg dib" style="height: 66px;line-height: 66px;padding: 0 30px;margin:20px 0 60px;width:80%">
                  {{info.invited_code}}
                  <img id="copycode" :data-clipboard-text="info.invited_code" @click="copy(info.invited_code)" src="../../static/images/copy.png">
                </div>
              </div>
              <div class="ac">
                <div class="">{{$t('referralTips3')}}</div>
                <div class="flex flex-center" style="margin:20px 0 60px;">
                  <input class="input" v-model="invited_code" style="width:45%;" />
                  <div class="title-bg fen" style="padding:5px 20px" @click="invitedCode">
                    {{$t('submit2')}}
                  </div>
                </div>
              </div>
              <div class="mt50 ac">{{$t('referral_tip')}}</div>
            </div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
import Clipboard from 'clipboard';
export default {
    components:{
		Header
    },
    data() {

    return {
			info:{},
      invited_code:'',
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.push({path:'/index'})
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.get('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
        that.info = r.data
      });

			})
		},
    invitedCode(){
      let that = this;
      let data = {
        invited_code:that.invited_code
      }
      that.$api.post('/api/user/invitedcode',data,r =>{
      	//that.$parent.returnCode(r,function(){
          that.$utils.alertText(r.msg);
       // });

      })
    },
    copy(item){
        var clipboard = new Clipboard("#copycode");
        clipboard.on("success", (e) => {
          this.$utils.alertText(this.$t('CopySucceeded'));
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          // 不支持复制
          //console.log("该浏览器不支持自动复制");
          // 释放内存
          clipboard.destroy();
        });
    }
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/referral.vue